import axios from "axios";
import React, { Component } from "react";
import { batch, connect } from "react-redux";
import PropTypes from "prop-types";
import { withRouter } from "react-router-dom";
import { createStory } from "../_actions/storiesActions";
import {
  StyledMarketplaceContent,
  StyledMarketplaceFrameDescription,
  StyledMarkerplaceCard,
  StyledMarketplaceFooter,
  StyledMarketplaceProjectFormatTitle,
  StyledDashboardBannerRow,
  StyledSectionTitle,
  StyledMarkerplaceHelpText,
  StyledTemplateViewAllSwiperButton,
} from "../_components/styled/home/stylesHome";
import {
  StyledCategories,
  StyledMarketplaceDesignCard,
} from "../_components/styled/styles";
import TLDRInfiniteScroll from "../_components/common/TLDRInfiniteScroll";
import {
  RequestTemplateContent,
  ShowCenterSpinner,
} from "../_components/common/statelessView";
import {
  fetchCategories,
  fetchFormats,
  searchFormats,
  resetSlidePresets,
} from "../_actions/slidePresetActions";
import TldrSearch from "../_components/common/TldrSearch";
import dashboardArtBoardPlaceholder from "../assets/images/dashboardArtBoardPlaceholder.png";
import { analyticsTrackEvent } from "../_utils/common";
import TLDRTitleSearch from "../_components/common/TLDRTitleSearch";
import TLDRSwiper from "../_components/common/TLDRSwiper";
import { FloatingButton } from "./TldrHomeBaseStyles";
import CustomSizeProjectModal from "../_components/common/CustomSizeProjectModal";
import {
  FaChevronLeft,
  FaChevronRight,
  FaCropAlt,
  FaPlus,
} from "react-icons/fa";
import { MAIN_CONTAINER_SCROLLABLE_TARGET_ID } from "../_utils/constants";
import { Box, Button, Flex, Icon } from "@chakra-ui/react";
import { withTranslation } from "react-i18next";

let viewAllTemplateCategoriesSwiperParams = {
  slidesPerView: "auto",
  freeMode: true,
  shouldSwiperUpdate: true,
  runCallbacksOnInit: true,
  mousewheel: false,
  containerClass: "marketplace-templates-category-swiper-container",
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
    disabledClass: "swiper-button-disabled",
  },
  renderPrevButton: () => (
    <StyledTemplateViewAllSwiperButton
      className={"swiper-button-prev"}
      variance="left"
    >
      <div className="swiper-button-inner-div">
        <FaChevronLeft />
      </div>
    </StyledTemplateViewAllSwiperButton>
  ),
  renderNextButton: () => (
    <StyledTemplateViewAllSwiperButton
      className={"swiper-button-next"}
      variance="right"
    >
      <div className="swiper-button-inner-div">
        <FaChevronRight />
      </div>
    </StyledTemplateViewAllSwiperButton>
  ),
};

class StartFromScratch extends Component {
  signal = axios.CancelToken.source();

  constructor(props) {
    super(props);
    this.state = {
      showCustomStorySizeModal: false,
      selectedCategory: "all",
      category: null,
    };
  }

  componentWillUnmount() {
    this.signal.cancel("The user aborted a request.");
  }

  loadMoreData = () => {
    this.fetchFormats("", this.props.page);
  };

  onFilterChange(key) {
    this.setState({ selectedCategory: key.id, category: key });
    this.props.resetSlidePresets();
    this.fetchFormats(key.id === "all" ? "" : key.id);
  }

  fetchCategories() {
    this.props
      .fetchCategories(this.props, this.signal.token)
      .then((result) => {})
      .catch((e) => {
        console.error(e);
      });
  }

  fetchFormats(key = "", page = 1) {
    this.props.fetchFormats(key, { ...this.props, page: page }).then(() => {});
  }

  componentDidMount() {
    batch(() => {
      this.props.resetSlidePresets();
      this.fetchCategories();
      this.fetchFormats();
    });
  }

  toggleCustomSizePopup = () => {
    this.setState((state) => ({
      selectedCategory: "custom",
      showCustomStorySizeModal: !state.showCustomStorySizeModal,
    }));
  };

  handleClick = (data) => {
    this.createStory(data);
  };

  onChange = (customWidth, customHeight) => {
    const design = {
      format_type: "custom",
      image_height: customHeight,
      image_width: customWidth,
      title: "Custom " + customHeight + "x" + customWidth + " px",
    };
    this.createStory(design);
  };

  createStory = (data) => {
    this.props.createStory(
      {
        status: "draft",
        template: data.format_type,
        format: data.id,
        title: data.display_name ? data.display_name : data.title,
        image_height: data.image_height,
        image_width: data.image_width,
        story_type: data.story_type,
      },
      this.signal.token,
      this.props
    );
  };

  handleSearch = (keyword) => {
    analyticsTrackEvent("searchFormats", {
      keyword: keyword,
    });
    batch(() => {
      this.props.resetSlidePresets();
      this.props.searchFormats(keyword, this.props).then(() => {});
    });
  };

  render() {
    const { t } = this.props;
    const { showCustomStorySizeModal, selectedCategory } = this.state;
    const { presetCategories, presets, loaded, hasMore } =
      this.props.slidePresets;
    const finalCategories = [
      { id: "all", title: "all", display_name: "All" },
    ].concat(presetCategories);

    const formatContent = presets.map((preset, index) => {
      const { id, image_height, image_width, title, display_name, image } =
        preset;

      return (
        <React.Fragment key={index}>
          <StyledMarkerplaceCard key={id} location="start-from-srcatch">
            <StyledMarketplaceDesignCard>
              <div
                className="start-from-scratch-thumbnail"
                onClick={() => this.handleClick(preset)}
              >
                <img
                  src={!image ? dashboardArtBoardPlaceholder : image}
                  alt={title}
                />
                <StyledMarketplaceFooter>
                  <StyledMarketplaceProjectFormatTitle>
                    {display_name}
                  </StyledMarketplaceProjectFormatTitle>
                  <StyledMarketplaceFrameDescription>
                    {image_width} x {image_height} px
                  </StyledMarketplaceFrameDescription>
                </StyledMarketplaceFooter>
              </div>
            </StyledMarketplaceDesignCard>
          </StyledMarkerplaceCard>
        </React.Fragment>
      );
    });

    const categoriesView = finalCategories.map((category) => {
      return (
        <Button
          key={category.id}
          variant="outline"
          borderRadius="full"
          borderColor={
            selectedCategory === category.id ? "primary.400" : "transparent"
          }
          color="gray.100"
          _hover={{ bg: "none", borderColor: "primary.400" }}
          _focus={{ borderColor: "primary.400", bg: "none" }}
          _active={{ borderColor: "primary.400", bg: "none" }}
          onClick={() => this.onFilterChange(category)}
          mr="1rem"
        >
          {category.display_name}
        </Button>
      );
    });

    return (
      <>
        <StyledMarketplaceContent className="scratch">
          <Flex
            className="start-from-scratch-hero-container"
            mt="-1.5rem"
            display={["none", "none", "flex", "flex"]}
            direction="column"
            justify="start"
          >
            <Flex
              as={StyledDashboardBannerRow}
              className="search-template-size"
              direction="column"
            >
              <StyledSectionTitle style={{ fontSize: "30px" }}>
                {t("intro_page.choose_size")}
              </StyledSectionTitle>
              <Box
                as={StyledMarkerplaceHelpText}
                className="marketplace-template-subheader"
                fontSize="1.125rem"
                color="gray.100"
              >
                {t("intro_page.choose_presets")}
              </Box>

              <TldrSearch
                placeholder={t("intro_page.search")}
                onSearch={this.handleSearch}
                size="xl"
                width={"100%"}
                height={"48px"}
                searchLocation="dashboard"
                showShadow={true}
              />
            </Flex>
            <StyledCategories className="pills-container">
              <div>{categoriesView}</div>

              {presetCategories.length > 0 && (
                <>
                  <Button
                    rightIcon={<FaPlus />}
                    variant="solid"
                    onClick={() => this.toggleCustomSizePopup()}
                  >
                    {t("custom_size")}
                  </Button>
                </>
              )}
            </StyledCategories>
          </Flex>

          {this.props.isMobileView ? (
              <TLDRTitleSearch
                searchConfig={{
                  handleSearch: this.handleSearch,
                }}
            />
          ) : null}
          <Box display={["flex", "flex", "none", "none"]}>
            <TLDRSwiper swiperParams={viewAllTemplateCategoriesSwiperParams}>
              {categoriesView}
            </TLDRSwiper>
          </Box>

          <Flex
            mx={["0", "1"]}
            m={["0", "3"]}
            p={["0", "1"]}
            direction="column"
            minHeight={"calc(100vh - 375px)"}
            wrap="nowrap"
            alignSelf={["auto", "center"]}
            overflowY={["hidden", "auto"]}
          >
            {loaded && presets.length > 0 ? (
              <TLDRInfiniteScroll
                className="start-from-scratch-presets-infinite-scroll"
                childrens={formatContent}
                hasMore={hasMore}
                loadMoreData={this.loadMoreData}
                loaded={loaded} // Change its value whenever data get loaded.
                scrollableTarget={MAIN_CONTAINER_SCROLLABLE_TARGET_ID}
              />
            ) : loaded && presets.length === 0 ? (
              <RequestTemplateContent text={t("intro_page.no_formats")} />
            ) : (
              <ShowCenterSpinner loaded={loaded} />
            )}
          </Flex>

          {showCustomStorySizeModal && (
            <CustomSizeProjectModal
              onHide={(e) => {
                this.setState({
                  selectedCategory: "all",
                  showCustomStorySizeModal: false,
                });
              }}
              onYes={this.onChange}
            ></CustomSizeProjectModal>
          )}
        </StyledMarketplaceContent>
        <Box
          as={FloatingButton}
          display={["flex", "flex", "none", "none"]}
          onClick={() => this.toggleCustomSizePopup()}
        >
          <Icon
            as={FaCropAlt}
            alignSelf="center"
            className="floating-add-product-icon "
            color="black"
          />
        </Box>
      </>
    );
  }
}

StartFromScratch.defaultProps = {
  page: 1,
};

StartFromScratch.propTypes = {
  page: PropTypes.number.isRequired,
  auth: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  slidePresets: state.slidePresets,
  auth: state.auth,
  page: state.slidePresets.page,
  isMobileView: state.app.isMobileView,
});

const mapDispatchToProps = {
  createStory,
  fetchCategories,
  fetchFormats,
  searchFormats,
  resetSlidePresets,
};

export default withTranslation(["common"])(
  connect(mapStateToProps, mapDispatchToProps)(withRouter(StartFromScratch))
);
